<template>
  <div class="align-items-center d-flex relative" v-if="showLanguageSelector">
    <b-dropdown
      class="language-selector text-gray-400"
      variant="light"
      v-model="locale"
      right
    >
      <template v-slot:button-content>
        <span class="show-flag shadow-sm" v-html="getFlag(language.flag)" />
      </template>
      <b-dropdown-item
        v-for="lang in langs"
        :key="lang.key"
        @click="locale = lang.key"
      >
        <span class="d-flex align-items-center gap-2">
          <span class="flag-list" v-html="getFlag(lang.flag)" />
          <span class="language-label">{{ lang.label }}</span>
        </span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import languages from "@/mixins/languages.js";
import Auth from "@/services/auth.js";

export default {
  name: "LanguageSelection",
  mixins: [languages],
  methods: {
    getFlag(name) {
      if (name === undefined) {
        return "";
      }
      return (
        '<span class="svg-flag">' +
        require("../../assets/img/flags/4x3/" + name + ".svg") +
        "</span>"
      );
    },
  },
  computed: {
    denseMode() {
      let lsDenseMode = window.V.$localStorage.get(
        "BPZ_" + Auth.getHash() + "_DENSE_MODE"
      );
      if (lsDenseMode === "1") {
        return true;
      }
      return false;
    },
    showLanguageSelector() {
      if (this.denseMode && this.$route.path === "/devices/licences") {
        return false;
      }
      return true;
    },
  },
  watch: {
    locale: function () {
      window.V.$localStorage.set("change_language", "defined");
      this.changeLanguage();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/_variables.scss";

.flag-list svg {
  width: 20px;
  height: auto;
  border-radius: 3px;
}

.language-selector button.btn {
  background-color: var(--colors-white);
  display: flex;
  align-items: center;
  box-shadow: var(--shadows-xs);
  gap: 0.75rem;
  box-shadow: var(--shadows-sm);
  min-height: 36px;
  border: 1px solid var(--colors-gray-300);
  &::after {
    color: var(--colors-gray-400);
  }

  > .show-flag svg {
    width: 25px;
    border-radius: 3px;
  }
}
</style>
